import { Component } from 'react'
import { Container, Row, Col } from 'reactstrap'
import withApolloClient from '../withApolloClient'
import IncidentListHeader from './IncidentsListHeader'
import IncidentList from './IncidentsList'
import IncidentActions from "./IncidentActions"
import './Incidents.css'
import ListingTabs from '../Material/ListingTabs'
import { buildPresets } from '../Filters/presetFilters'
import { FILTER_PARAM } from '../Filters/filterUrl'
import ReportsPanel from '../Reports/ReportsPanel'


const tableHeaders = [
    { id: "id", name: "Date Added", sortable: true, preferenceSettings: { isVisible: true, canToggleVisibility: true, canReorder: true } },
    { id: "data_progress", name: "Data Progress", sortable: false, preferenceSettings: { isVisible: true, canToggleVisibility: true, canReorder: true } },
    { id: "title", name: "Incident Name", sortable: false, preferenceSettings: { isVisible: true, canToggleVisibility: true, canReorder: true } },
    { id: "assignedTo", name: "Assigned To", sortable: false, preferenceSettings: { isVisible: true, canToggleVisibility: true, canReorder: true } },
    { id: "car__id", name: "Car", sortable: false, preferenceSettings: { isVisible: true, canToggleVisibility: true, canReorder: true } },
    { id: "car_vin", name: "Vin", sortable: false, preferenceSettings: { isVisible: true, canToggleVisibility: true, canReorder: true } },
    { id: "incident_branch", name: "Incident Branch", sortable: false, preferenceSettings: { isVisible: true, canToggleVisibility: true, canReorder: true } },
    { id: "dmvPlate", name: "DMV Plate", sortable: false, preferenceSettings: { isVisible: true, canToggleVisibility: true, canReorder: true } },
    { id: "driver__id", name: "Driver", sortable: false, preferenceSettings: { isVisible: true, canToggleVisibility: true, canReorder: true } },
    { id: "notificationDate", name: "Notification Date", sortable: true, preferenceSettings: { isVisible: true, canToggleVisibility: true, canReorder: true } },
    { id: "incidentDate", name: "Incident Date", sortable: true, preferenceSettings: { isVisible: true, canToggleVisibility: true, canReorder: true } },
    { id: "incidentTime", name: "Incident Time", sortable: false, preferenceSettings: { isVisible: true, canToggleVisibility: true, canReorder: true } },
    { id: "status", name: "Status", sortable: false, preferenceSettings: { isVisible: true, canToggleVisibility: true, canReorder: true } },
    { id: "incidentType", name: "Incident Type", sortable: false, preferenceSettings: { isVisible: true, canToggleVisibility: true, canReorder: true } },
    { id: "source", name: "Source", sortable: false, preferenceSettings: { isVisible: true, canToggleVisibility: true, canReorder: true } },
    { id: "responsibleParty", name: "Responsible Party", sortable: false, preferenceSettings: { isVisible: true, canToggleVisibility: true, canReorder: true } },
    { id: "reportedBy", name: "Reported By", sortable: false, preferenceSettings: { isVisible: true, canToggleVisibility: true, canReorder: true } },
    { id: "incidentState", name: "Incident State", sortable: true, preferenceSettings: { isVisible: true, canToggleVisibility: true, canReorder: true } },
    { id: "location", name: "Location", sortable: false, preferenceSettings: { isVisible: true, canToggleVisibility: true, canReorder: true } },
    { id: "carOnHold", name: "Car On Hold", sortable: true, preferenceSettings: { isVisible: true, canToggleVisibility: true, canReorder: true } },
    { id: "ridesharePlatform", name: "Rideshare Platform", sortable: true, preferenceSettings: { isVisible: true, canToggleVisibility: true, canReorder: true } },
    { id: "ridesharePeriod", name: "Rideshare Period", sortable: true, preferenceSettings: { isVisible: true, canToggleVisibility: true, canReorder: true } },
    { id: "ridesharePeriodSource", name: "Rideshare Period Source", sortable: true, preferenceSettings: { isVisible: true, canToggleVisibility: true, canReorder: true } },
    { id: "carTotaled", name: "Car Totaled", sortable: true, preferenceSettings: { isVisible: true, canToggleVisibility: true, canReorder: true } },
    { id: "hasPoliceReport", name: "Police Report?", sortable: true, preferenceSettings: { isVisible: true, canToggleVisibility: true, canReorder: true } },
    { id: "hasDashcamVideos", name: "Dashcam Videos?", sortable: true, preferenceSettings: { isVisible: true, canToggleVisibility: true, canReorder: true } },
    { id: "hasOtherParties", name: "Other Parties?", sortable: true, preferenceSettings: { isVisible: true, canToggleVisibility: true, canReorder: true } },
    { id: "hasLiabilityClaim", name: "Liability Claim?", sortable: true, preferenceSettings: { isVisible: true, canToggleVisibility: true, canReorder: true } },
    { id: "hasSubroClaim", name: "Subro Claim?", sortable: true, preferenceSettings: { isVisible: true, canToggleVisibility: true, canReorder: true } },
    { id: "isRecordOnly", name: "Is Record Only?", sortable: true, preferenceSettings: { isVisible: true, canToggleVisibility: true, canReorder: true } },
]
const getDefaultColumnConfig = () => tableHeaders.map((column, index) => ({ ...column, order: index }))

// Each tab's default filters, expressed as Advanced Filters presets -- the same
// FilterInput[] shape the query already sends for user filters, so the popover,
// the chips and the query all read one source of truth.
//
// "Not archived" is editable and removable: drop the chip to see archived
// incidents. The assignment scope is locked (rendered with a padlock), because
// it is what distinguishes one tab from another -- to widen it, switch tabs.
const NOT_ARCHIVED_PRESET = { fieldName: "is_archived", filterType: "equal", filterValues: "false", editable: true, visible: true }

export const INCIDENT_LISTING_TABS = [
    {
        id: "#assigned", name: "Assigned Incidents", iconClassName: "fa fa-user-o",
        getPresetFilters: (currentUser) => [
            NOT_ARCHIVED_PRESET,
            // assigned_to is an M2M; the engine decodes the relay global id.
            ...(currentUser?.id ? [{ fieldName: "assigned_to", filterType: "equal", filterValues: currentUser.id, editable: false, visible: true }] : []),
        ],
    },
    {
        id: "#notassingend", name: "Pending Assignments", iconClassName: "fa fa-user-times",
        getPresetFilters: () => [
            NOT_ARCHIVED_PRESET,
            { fieldName: "assigned_to", filterType: "is_null", filterValues: null, editable: false, visible: true },
        ],
    },
    { id: "#all", name: "All Incidents", iconClassName: "fa fa-list-ul", getPresetFilters: () => [NOT_ARCHIVED_PRESET] },
    { id: "#reports", name: "Activity Log", iconClassName: "fa fa-history", floatRight: true, iconOnly: true, getPresetFilters: () => [] },
]

export const getPresetsForTab = (tabId, currentUser) =>
    buildPresets(INCIDENT_LISTING_TABS.find(tab => tab.id === tabId)?.getPresetFilters(currentUser) || [])

const getInitialTab = () => {
    const allowedTabs = INCIDENT_LISTING_TABS.map(item => item.id)
    return typeof window !== "undefined" && window.location.hash && allowedTabs.includes(window.location.hash)
        ? window.location.hash
        : INCIDENT_LISTING_TABS[0].id
}

class IncidentListContainer extends Component {
    constructor(props) {
        super(props)
        const initialTab = getInitialTab()
        // presets and defaultPresets start out equal -- setPresets only ever
        // updates presets, so defaultPresets stays the active tab's declared
        // set and is what Reset returns to.
        const initialPresets = getPresetsForTab(initialTab, props.currentUser)
        this.state = {
            orderBy: ["-notificationDate"],
            // filterValues now only carries the header's search term; every other
            // filter is a preset or a user advanced filter.
            filterValues: {},
            presets: initialPresets,
            defaultPresets: initialPresets,
            refetchIncidents: false,
            tab: initialTab,
            renderedTabPanes: [initialTab],
            columnConfig: getDefaultColumnConfig(),
            selectedIncidents: [],
        }
    }
    setColumnConfig = (columnConfig) => this.setState({ columnConfig })

    updateOrder = (string) => {
        let order = this.state.orderBy ? [...this.state.orderBy] : []
        let index = order.indexOf(string)
        if (index > -1) {
            order[index] = "-" + string
        } else {
            index = order.indexOf("-" + string)
            index > -1 ? order.splice(index, 1) : order.unshift(string)
        }
        this.setState({ orderBy: order })
    };

    // Writes the tab hash through navigate() (path + search + hash together) instead
    // of `window.location.hash = …`. The direct write left react-router's own
    // location.hash -- read by useLocation() everywhere, including
    // Filters/filterUrl.js -- stale, and it never touched `?filter=`.
    //
    // `?filter=` is one shared query param, and every listing tab here shows the
    // same `incident` entity, so a filter applied on one tab stayed in the URL and
    // applied cleanly on the next: the user switched tabs and silently got a
    // narrowed list they never filtered. Same fix as CarReturnListContainer and
    // AvailableCars/AvailableCarsContainer.
    //
    // Mount is the exception (clearFilters: false). Because every tab is the same
    // entity, a shared link's filters are always valid here -- stripping them on
    // load would break filtered links outright, which is not the problem being
    // solved.
    navigateToTab = (tabId, { replace = false, clearFilters = true } = {}) => {
        const params = new URLSearchParams(this.props.location.search)
        if (clearFilters) params.delete(FILTER_PARAM)
        this.props.navigate(
            { pathname: this.props.location.pathname, search: params.toString(), hash: tabId },
            { replace }
        )
    }

    toggleTab = (tabId) => {
        if (!this.state.renderedTabPanes.includes(tabId)) {
            this.setState({ renderedTabPanes: [...this.state.renderedTabPanes, tabId] })
        }
        const nextPresets = getPresetsForTab(tabId, this.props.currentUser)
        this.setState({
            tab: tabId,
            filterValues: {},
            presets: nextPresets,
            defaultPresets: nextPresets,
            selectedIncidents: [],
        })
        this.navigateToTab(tabId)
    }

    setPresets = (presets) => this.setState({ presets, selectedIncidents: [] })

    componentDidMount() {
        let defaultTab = INCIDENT_LISTING_TABS[0].id
        const allowedTabs = [...INCIDENT_LISTING_TABS.map(item => item.id)]
        if (!window.location.hash || !allowedTabs.includes(window.location.hash)) {
            this.setState({ tab: defaultTab, renderedTabPanes: [defaultTab] })
            this.navigateToTab(defaultTab, { replace: true, clearFilters: false })
        }
    }
    // No componentDidUpdate hash write any more: toggleTab navigates directly, so
    // mirroring the tab into the hash a render later would double-write and undo
    // the `?filter=` clearing that navigate() just did.


    render() {
        return (
            <Container fluid className="bos-listing-container">
                <ListingTabs
                    tabs={INCIDENT_LISTING_TABS}
                    activeTab={this.state.tab}
                    onChange={this.toggleTab}
                />
                {this.state.tab !== "#reports" && <Row>
                    <Col xs={8}>
                        <IncidentListHeader
                            filterValues={this.state.filterValues}
                            setFilterValues={(filterValues) => this.setState({ filterValues, selectedIncidents: [] })}
                            presets={this.state.presets}
                            setPresets={this.setPresets}
                            defaultPresets={this.state.defaultPresets}
                            {...this.props}
                        />
                    </Col>
                    <Col xs={4}>
                        <IncidentActions
                            columnConfig={this.state.columnConfig}
                            setColumnConfig={this.setColumnConfig}
                            tableId="incident"
                            defaultColumnConfig={getDefaultColumnConfig()}
                            refetchQuery={() => this.setState({ refetchIncidents: !this.state.refetchIncidents })}
                            selectedIncidents={this.state.selectedIncidents}
                            clearSelectedIncidents={() => this.setState({ selectedIncidents: [] })}
                            {...this.props}
                        />
                    </Col>
                </Row>}
                <Row>
                    <Col sm="12">
                        {this.state.tab === "#reports" ?
                            <ReportsPanel reportId="incidents" />
                            :
                            <IncidentList
                                columnConfig={this.state.columnConfig}
                                key={String(this.state.refetchIncidents)}
                                currentUser={this.props.currentUser}
                                selectedIncidents={this.state.selectedIncidents}
                                setSelectedIncidents={(selectedIncidents) => this.setState({ selectedIncidents })}
                                presets={this.state.presets}
                                searchTerm={this.state.filterValues?.searchTerm || null}
                                orderBy={this.state.orderBy}
                                updateOrder={this.updateOrder}
                            />}
                    </Col>
                </Row>
            </Container>
        )
    }
}



export default withApolloClient(
    IncidentListContainer
)
